import React from 'react';
import $ from "jquery";
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import ReactPaginate from 'react-paginate';

import { sendRequest } from './global.js';
import Storage, {T} from './Storage.js';
import { generateAct } from './ActGenerator.js';
import { generateCourierAct } from './CourierActGenerator.js';

import SearchView from './SearchView.js';
import ObjectListElem from './ObjectListElem.js';
import FlexibleInput from './FlexibleInput.js';
import TextInput from './input/TextInput.js';
import DateInput from './input/DateInput.js';
import SelectInput from './input/SelectInput.js';

$(document).ready(() => {
  localStorage.removeItem("ObjectListView-key");
  localStorage.removeItem("ObjectListView-page");
  localStorage.removeItem("ObjectListView-search");
});

let ITEMS_PER_PAGE = 20;

export default class ObjectListView extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState(props);
  }
  
  getDefaultState = (props) => {
    props = props || this.props;
    var state = {
      objects : [],
      properties: Storage.getConfig(props.configKey).properties,
      config: Storage.getConfig(props.configKey).config, 
      showConfirm: false, 
      pendingDelete: {},
      responseContent: false,
      search: {
        scope: "headers", 
        paginate: true, 
        offset: 0,
      },
      export: {
        selected: [],
        current: null,
        disabled: true
      },
      page: 0
    };
    // Default search interval
    if (state.config.search) {
      Object.keys(state.config.search).forEach((key) => {
        state.search[key] = state.config.search[key].default || null;
      });
    }
    return state;
  }

  componentWillReceiveProps = (props) => {
  }

  componentDidMount = () => {
    if (localStorage.getItem("ObjectListView-key") === this.props.configKey) {
      var page = parseInt(localStorage.getItem("ObjectListView-page"), 10) || 0;
      var search = JSON.parse(localStorage.getItem("ObjectListView-search")) || {scope: "headers"};  
      search.paginate = true;
      search.offset = page * ITEMS_PER_PAGE;
      this.setState({page: page, search: search});
      this.state.search = search; // eslint-disable-line
    } else {
      localStorage.removeItem("ObjectListView-key");
      localStorage.removeItem("ObjectListView-page");
      localStorage.removeItem("ObjectListView-search");
    }

    this.requestData();
  }

  updateStateWithData = (data) => {
    let stateChange = {
      page: this.state.page,
    };
    // add or remove objects to fit new count
    stateChange.objects = this.state.objects.splice(0, data.count);
    for (let i = stateChange.objects.length; i < data.count; i++) {
      stateChange.objects.push({});
    }
    // drop page number to fit new count
    let pageNum = Math.ceil(data.count / ITEMS_PER_PAGE);
    if (stateChange.page >= pageNum) {
      stateChange.page = 0;
    }
    // save new objects
    for (let i = 0; i < data.objects.length; i++) {
      let index = stateChange.page * ITEMS_PER_PAGE + i;
      stateChange.objects[index] = data.objects[i];
    }
    this.setState(stateChange);
  }

  requestData = (state) => {
    if (typeof state === "undefined") {
      state = this.state;
    }
    let data = {};
    if (typeof state.search !== "undefined") {
      data = state.search;
    }
    data.scope = "headers";
    data.paginate = true;
    data.offset = state.page * ITEMS_PER_PAGE;
    sendRequest({
      method: state.config.method,
      data: data,
      type: "GET",
      success: (data) => {
        this.updateStateWithData(data);
      },
      error: (xhr, status, err) => {
      }
    });
  }

  onObjectDelete = (object) => {
    this.setState({pendingDelete: object, showConfirm: true});
  }

  onDeleteCancel = (e) => {
    this.setState({pendingDelete: {}, showConfirm: false});
  }

  onDeleteConfirm = (e) => {
    var object = this.state.pendingDelete;
    sendRequest({
      method: this.state.config.method + object.id,
      type: "DELETE",
      success: (data) => {
        this.setState({pendingDelete: {}, showConfirm: false});
        this.requestData(this.state);
      },
      error: (xhr, status, err) => {
      }
    });
  }

  onSearch = (search) => {
    var data = this.state.search;
    var keys = Object.keys(search);
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!search[key]) {
        data[key] = null;
        continue;
      }
      if (this.state.config.search[key].type === "text") {
        data[key] = search[key]; 
      }
      if (this.state.config.search[key].type === "select") {
        data[key] = search[key].id || search[key].value;
      }
      if (this.state.config.search[key].type === "multi") {
        data[key] = [];
        for (let j = 0; j < search[key].length; j++) {
          data[key].push(search[key][j].id); 
        }
      }
      if (this.state.config.search[key].type === "date-interval") {
        data[key] = {
          from: search[key].from,
          to: search[key].to,
        };
      }
      if (this.state.config.search[key].type === "address") {
        data[key] = search[key];
      }
      if (this.state.config.search[key].type === "scan") {
        data[key] = search[key].filter(value => !isNaN(parseInt(value, 10)));
      }
    }
    
    var exp = this.state.export;
    exp.selected = [];
    exp.current = null;
    exp.disabled = true;
    this.setState({export: exp, page: 0});

    this.requestData();
  }

  onSelect = (objectId, select) => {
    var exp = Object.assign({}, this.state.export);
    if (select) {
      exp.selected.push(objectId);
    } else {
      exp.selected.splice($.inArray(objectId, exp.selected), 1);
    }
    this.setState({export: exp});
  }

  onSelectAll = (e) => {
    var exp = Object.assign({}, this.state.export);
    exp.selected = [];
    var select = this.state.export.selected.length !== this.state.objects.length;
    if (select) {
      for (let i = 0; i < this.state.objects.length; i++) {
        if (!this.state.objects[i].deleted) {
          exp.selected.push(this.state.objects[i].id);
        }
      }
    }
    this.setState({export: exp});
  }

  exportCourierAct = ({courier, from, to}) => {
    sendRequest({
      method: 'mailings/for_courier',
      type: 'GET',
      data: {
        courier_id: courier.value,
        from,
        to,
      },
      success: (data) => {
        generateCourierAct(
          courier.value,
          {
            from: new Date(from).toLocaleDateString(),
            to: new Date(to).toLocaleDateString(),
          },
          data
        );
      },
      error: (xhr, status, err) => {
      }
    });
  }

  exportAct = (act, {type, number, from, to}) => {
    const method = type === 'number' ? 'mailings/for_act_and_id' : 'mailings/for_dates';
    const data = type === 'number' ? { act, id: number } : { act, from, to };
    sendRequest({
      method,
      type: 'GET',
      data,
      success: (data) => {
        generateAct(
          act,
          {
            type,
            number,
            from: new Date(from).toLocaleDateString(),
            to: new Date(to).toLocaleDateString(),
          },
          data
        );
      },
      error: (xhr, status, err) => {
      }
    });
  }

  onExport = (e) => {
    if ($(e.currentTarget).attr("disabled")) {
      return;
    }
    var button = $(e.target);
    var key = button.attr("data-key");
    var singleExport = this.state.config.export[key];
    var exp = this.state.export;
    exp.current = singleExport;
    exp.disabled = (!singleExport.value && !singleExport.type === "scan")
      || ["act", "act_courier"].includes(singleExport.type);
    this.setState({export: exp});
  }

  onExportCancel = (e) => {
    var exp = this.state.export;
    exp.current = null;
    exp.disabled = true;
    this.setState({export: exp});
  }
  
  onExportConfirm = (e) => {
    const singleExport = this.state.export.current;
    let data = {};
    let requestType = "GET";
    if (singleExport.type === "act_courier") {
      this.exportCourierAct(this.state.export.current.value)
      return;
    }
    if (singleExport.type === "act") {
      this.exportAct(this.state.export.current.act, this.state.export.current.value)
      return;
    }
    if (singleExport.type === "print") {
      const value = singleExport.value || {};
      if (value.form) {
        const selected = this.state.export.selected.filter((item) => !!item);
        localStorage.setItem("print_ids", JSON.stringify(selected));
        const url = "print.html?" + $.param({
          print_form: singleExport.value.form.value,
          split: value.split ? value.split.value : 'normal',
          squeeze: !!value.squeeze,
        })
        const win = window.open(url, "_system");
        win.focus();
      }
      return;
    }
    if (singleExport.type === "print_interval") {
      const value = singleExport.value || {};
      if (value.from && value.to && value.form) {
        const url = "print.html?" + $.param({
          print_form: singleExport.value.form.value,
          from: singleExport.value.from,
          to: singleExport.value.to,
          split: value.split ? value.split.value : 'normal',
          squeeze: !!value.squeeze,
        })
        const win = window.open(url, "_system");
        win.focus();
      }
      return;
    }
    if (singleExport.type === "scan") {
      requestType = "POST";
      Object.keys(singleExport.fields).forEach((key) => {
        if (singleExport.value[key] || singleExport.value[key] === false) {
          data[key] = singleExport.value[key];
        }
      });
      data.scan = (data.scan || []).filter(value => !isNaN(parseInt(value, 10)));
      data.print = singleExport.value.print;
    }
    if (singleExport.type === "create") {
      requestType = "POST";
      data[singleExport.nameParameter] = $('input[data-id="export_create"]').val();
    }
    if (singleExport.type === "choose") {
      requestType = "POST";
      data[singleExport.idParameter] = singleExport.value.value;
    }
    if (singleExport.type === "upload") {
      requestType = "POST";
      data[singleExport.fileParameter] = singleExport.value;
    }
    if (!singleExport.noSelect) {
      data[singleExport.listParameter] = this.state.export.selected;
    }
    sendRequest({
      method: singleExport.method,
      type: requestType,
      data: data,
      success: (response) => {
        if (this.state.export.current) {
          var exp = this.state.export;
          exp.current = null;
          var stateChange = {export: exp};
          if (!response.status || response.status !== "ok") {
            stateChange.responseContent = response;
          }
          this.setState(stateChange);
          this.requestData();
        } else {
          this.setState({responseContent: response});
        }
      },
      error: (xhr, status, err) => {
      }
    });
  }

  onModalClose = () => {
    this.setState({responseContent: false});
  }

  handlePageClick = (e) => {
    var state = Object.assign({}, this.state);
    state.page = e.selected;
    this.requestData(state);
    this.setState({page: e.selected});
  }

  handlePageGo = () => {
    var page = parseInt($(this.pageInput).val(), 10);
    if (page) {
      page--;
      var state = Object.assign({}, this.state);
      state.page = page;
      this.requestData(state);
      this.setState({page});
    }
  }

  storePage = () => {
    localStorage.setItem("ObjectListView-key", this.props.configKey);
    localStorage.setItem("ObjectListView-page", this.state.page);
    localStorage.setItem("ObjectListView-search", JSON.stringify(this.state.search));
  }

  onObjectView = (object) => {
    if(getSelection().toString()){
        return;
    }
    this.storePage();
    $(document).trigger("changePage", [this.props.configKey, object]);
  }

  onObjectEdit = (object) => {
    this.storePage();
    $(document).trigger("changePage", [this.props.configKey, object, "edit"]);
  }

  onObjectCreate = () => {
    this.storePage();
    $(document).trigger("changePage", [this.props.configKey, {id: false}, "create"]);
  }

  renderPagination = () => {
    var pageNum = Math.ceil(this.state.objects.length / ITEMS_PER_PAGE);
    if (pageNum > 1) {
      return (
        <div className="paginationContainer">
          <ReactPaginate 
            previousLabel={T("page_previous")}
            nextLabel={T("page_next")}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={pageNum}
            forcePage={this.state.page}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} 
          />
          <input
            type="number"
            placeholder={T("page_placeholder")}
            className="form-control"
            ref={(input) => {this.pageInput = input}}
            min={1}
            max={pageNum}
          />
          <input 
            type="button"
            value={T("page_go")}
            className="btn button-go"
            onClick={this.handlePageGo}
          />
        </div>
      )
    } else {
      return null;
    }
  }

  renderResponse = () => {
    var responseBody = [];
    if (this.state.responseContent) {
      let content = this.state.responseContent;
      if ($.isArray(content.error)) {
        responseBody.push( content.error.map((err, i) => {
          return <span key={"error" + i} className="errorMessage">{err}</span>;
        }) );
      } else if (typeof content.error === "string") {
        responseBody.push( <span key="error" className="errorMessage">{content.error}</span> );
      }
      if (content.message) {
        if (responseBody.length > 0) {
          responseBody.push( <br key={"br" + responseBody.length}/> );
        }
        responseBody.push( content.message );
      }
      if (content.link) {
        if (responseBody.length > 0) {
          responseBody.push( <br key={"br" + responseBody.length}/> );
        }
        if (typeof content.link === "string") {
          responseBody.push( <a key="link" href={content.link} target="_blank">{T("modal_response_link")}</a> );
        } else {
          responseBody.push( <a key="link" href={content.link.href} target="_blank">{content.link.label}</a> );
        }
      }
      if (content.copyable) {
        if (responseBody.length > 0) {
          responseBody.push( <br key={"br" + responseBody.length}/> );
        }
        let copyToClipboard = (e) => {
          let input = $(e.currentTarget).parent().find("input");
          input.focus();
          input[0].setSelectionRange(0, input.val().length);
          try {
            console.log(document.execCommand("copy"));
          } catch(e) {}
        }
        responseBody.push( <div key="copyable" className="copyable">
          <input value={content.copyable} readOnly={true} className="form-control"/>
          <button className="btn btn-default" onClick={copyToClipboard}>
            <i className="fa fa-clipboard"></i>
          </button> 
        </div> );
      }
    }

    return (
      <Modal show={!!this.state.responseContent} onHide={this.onModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{T("modal_response_title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {responseBody}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onModalClose}>{T("button_close")}</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderExportCreate = () => {
    const singleExport = this.state.export.current;
    return (
      <input
        type="text"
        data-id="export_create"
        placeholder={singleExport.placeholder}
        className="form-control"
        onChange={(e) => {
          var exp = this.state.export;
          if (exp.disabled ^ e.target.value.length === 0) {
            exp.disabled = e.target.value.length === 0;
          }
          this.setState({export: exp});
        }}
      />
    )
  }

  renderExportUpload = () => {
    const singleExport = this.state.export.current;
    return (
      <input
        type="file"
        data-id="export_upload"
        accept={singleExport.accept}
        className="form-control"
        onChange={(e) => {
          var exp = this.state.export;
          exp.disabled = e.target.files.length === 0;
          if (e.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = (e) => {
              exp.current.value = e.target.result;
              this.setState({export: exp});
            }
            reader.readAsDataURL(e.target.files[0]);
          } else {
            exp.current.value = null;
            this.setState({export: exp});
          }
        }}
      />
    )
  }

  renderExportChoose = () => {
    const singleExport = this.state.export.current;
    const getOptions = (input, callback) => {
      sendRequest({
        method: singleExport.optionsRequest,
        type: "GET",
        data: {scope: "headers"},
        success: (data) => {
          var options = [];
          for (let i = 0; i < data.length; i++) {
            if (typeof data[i] === "string") {
              options.push({value: data[i], label:data[i]});
            } else {
              options.push({value: data[i].id, label:data[i].name});
            }  
          }
          if (options.length > 0) {
            var exp = this.state.export;
            exp.disabled = false;
            exp.current.value = options[0];
            this.setState({export: exp});
          }
          callback(null, {options: options, complete: true});
        }
      });
    }
    return (
      <Select.Async
        name="form-field-name"
        data-id="export_choose"
        placeholder={singleExport.placeholder}
        clearable={false}
        loadOptions={getOptions}
        value={singleExport.value}
        onChange={(e) => {
          var exp = this.state.export;
          exp.disabled = false;
          exp.current.value = e;
          this.setState({export: exp});
        }}
      />
    )
  }

  renderExportPrint = () => {
    const singleExport = this.state.export.current;
    const value = singleExport.value || {};
    const options = Object.keys(singleExport.options).map(key => ({
      value: key,
      label: singleExport.options[key]
    }));
    const onChange = (key, val, handle) => {
      let exp = this.state.export;
      if (!exp.current.value) {
        exp.current.value = {};
      }
      exp.current.value[key] = val;
      this.setState({export: exp}, handle);
    }
    const split = (value.split || {}).value;
    return (
      <div className="print-form">
        <Select
          data-id="export_print"
          placeholder={singleExport.placeholder}
          clearable={false}
          options={options}
          value={value.form}
          onChange={e => onChange("form", e)}
        />
        {value.form && value.form.value === 'for_client' ? null : <div>
          <Select
            data-id="export_print"
            placeholder='Тип печати'
            clearable={false}
            options={[
              { value: 'normal', label: 'Печать в офисе' },
              { value: 'split_3', label: 'Печать на производстве (3 на лист)' },
              { value: 'split_4', label: 'Печать на производстве (4 на лист)' },
            ]}
            value={value.split}
            onChange={e => onChange("split", e)}
          />
          <label className="control-label">Сжать форму (узкий лист)</label>
          <input
            type="checkbox"
            data-id="export_print"
            checked={
              split === 'split_3' ? true :
              split === 'split_4' ? false :
              value.squeeze || false
            }
            onChange={() => onChange("squeeze", !value.squeeze)}
            disabled={['split_3', 'split_4'].indexOf(split) > -1}
          />
        </div>}
      </div>
    )
  }

  renderExportPrintInterval = () => {
    const singleExport = this.state.export.current;
    const value = singleExport.value || {};
    const options = Object.keys(singleExport.options).map(key => ({
      value: key,
      label: singleExport.options[key]
    }));
    const onChange = (key, val, handle) => {
      let exp = this.state.export;
      if (!exp.current.value) {
        exp.current.value = {};
      }
      exp.current.value[key] = val;
      this.setState({export: exp}, handle);
    }
    const split = (value.split || {}).value;
    return (
      <div className="interval-form">
        <label className="control-label">Номера отправлений</label>
        <TextInput
          placeholder="с"
          objectKey="from"
          properties={{type: "text"}}
          object={value.from || ""}
          onChange={onChange}
        />
        <TextInput
          placeholder="по"
          objectKey="to"
          properties={{type: "text"}}
          object={value.to || ""}
          onChange={onChange}
        />
        <Select
          data-id="export_print"
          placeholder={singleExport.placeholder}
          clearable={false}
          options={options}
          value={value.form}
          onChange={e => onChange("form", e)}
        />
        {value.form && value.form.value === 'for_client' ? null : <div>
          <Select
            data-id="export_print"
            placeholder='Тип печати'
            clearable={false}
            options={[
              { value: 'normal', label: 'Печать в офисе' },
              { value: 'split_3', label: 'Печать на производстве (3 на лист)' },
              { value: 'split_4', label: 'Печать на производстве (4 на лист)' },
            ]}
            value={value.split}
            onChange={e => onChange("split", e)}
          />        
          <label className="control-label">Сжать форму (узкий лист)</label>
          <input
            type="checkbox"
            data-id="export_print"
            checked={
              split === 'split_3' ? true :
              split === 'split_4' ? false :
              value.squeeze || false
            }
            onChange={() => onChange("squeeze", !value.squeeze)}
            disabled={['split_3', 'split_4'].indexOf(split) > -1}
          />
        </div>}
      </div>
    )
  }

  renderExportScan = () => {
    const singleExport = this.state.export.current;
    const options = Object.keys(singleExport.print_options).map(key => ({
      value: key,
      label: singleExport.print_options[key],
    }));
    return (
      <div className="scan-form">
        {Object.keys(singleExport.fields).map((key) => {
          let field = singleExport.fields[key];
          let defaultVal = field.type === "text" ? "" : null;
          let value = (singleExport.value && singleExport.value[key]) || defaultVal;
          return <div key={key}>
            <label className="control-label">{field.title}</label>
            {key === "scan" ?
              <div className="scan-count">
                Всего {(value || []).filter(value => !isNaN(parseInt(value, 10))).length}
              </div>
            : null}
            <FlexibleInput
              object={value}
              objectKey={key}
              objectProperties={singleExport.fields}
              onChange={(key, val) => {
                var exp = this.state.export;
                if (!exp.current.value) {
                  exp.current.value = {};
                }
                exp.current.value[key] = val;
                this.setState({export: exp});
              }}
            />
          </div>
        })}
        <label className="control-label">{singleExport.printTitle}</label>
        <Select
          name="form-field-name"
          data-id="export_print"
          placeholder={T("input_select")}
          options={options}
          value={(singleExport.value && singleExport.value.print) || null}
          onChange={(val) => {
            var exp = this.state.export;
            if (!exp.current.value) {
              exp.current.value = {};
            }
            exp.current.value.print = val;
            exp.disabled = !val;
            this.setState({export: exp});
          }}
        />
      </div>
    )
  }

  renderExportAct = () => {
    const singleExport = this.state.export.current;
    return (
      <div className="scan-form">
        <SelectInput
          properties={{
            type: 'select',
            options: [
              { value: 'period', label: 'За период' },
              { value: 'number', label: 'По номеру отправления' },
            ]
          }}
          object={(singleExport.value && singleExport.value.type) || 'period'}
          onChange={(k, val) => {
            let exp = this.state.export;
            if (!exp.current.value) {
              exp.current.value = {};
            }
            exp.current.value.type = val;
            exp.disabled = val === 'number'
              ? !exp.current.value.number
              : (!exp.current.value.from || !exp.current.value.to);
            this.setState({export: exp});
          }}
        />
        {singleExport.value && singleExport.value.type === 'number' ? <div>
          <label className="control-label">Номер отправления</label>
          <TextInput
            properties={{
              type: 'text',
            }}
            object={(singleExport.value && singleExport.value.number) || ''}
            onChange={(k, val) => {
              let exp = this.state.export;
              if (!exp.current.value) {
                exp.current.value = {};
              }
              exp.current.value.number = val;
              exp.disabled = !exp.current.value.number;
              this.setState({export: exp});
            }}
          />
        </div> : <div>
          <label className="control-label">Начало периода</label>
          <DateInput
            name="form-field-name"
            data-id="export_print"
            object={(singleExport.value && singleExport.value.from) || null}
            onChange={(k, val) => {
              let exp = this.state.export;
              if (!exp.current.value) {
                exp.current.value = {};
              }
              exp.current.value.from = val;
              exp.disabled = !exp.current.value.from || !exp.current.value.to;
              this.setState({export: exp});
            }}
          />
          <label className="control-label">Конец периода</label>
          <DateInput
            name="form-field-name"
            data-id="export_print"
            object={(singleExport.value && singleExport.value.to) || null}
            onChange={(k, val) => {
              let exp = this.state.export;
              if (!exp.current.value) {
                exp.current.value = {};
              }
              exp.current.value.to = val;
              exp.disabled = !exp.current.value.from || !exp.current.value.to;
              this.setState({export: exp});
            }}
          />
        </div>}
        
      </div>
    )
  }

  renderCourierAct = () => {
    const singleExport = this.state.export.current;
    return (
      <div className="scan-form">
        <label className="control-label">Курьер</label>
        <Select.Async
          name="form-field-name"
          placeholder="Выбрать"
          clearable={false}
          loadOptions={(input, callback) => {
            sendRequest({
              method: "couriers/all",
              type: "GET",
              data: {scope: "headers"},
              success: (data) => {
                callback(null, {
                  options: data.map(i => ({value: i.id, label: i.name})),
                  complete: true
                });
              }
            });
          }}
          value={singleExport.value && singleExport.value.courier}
          onChange={(e) => {
            var exp = this.state.export;
            exp.current.value = { ...exp.current.value, courier: e };
            exp.disabled = !exp.current.value.from || !exp.current.value.to;
            this.setState({export: exp});
          }}
        />
        <label className="control-label">Начало периода</label>
        <DateInput
          name="form-field-name"
          data-id="export_print"
          object={(singleExport.value && singleExport.value.from) || null}
          onChange={(k, val) => {
            let exp = this.state.export;
            if (!exp.current.value) {
              exp.current.value = {};
            }
            exp.current.value.from = val;
            exp.disabled = !exp.current.value.courier || !exp.current.value.to;
            this.setState({export: exp});
          }}
        />
        <label className="control-label">Конец периода</label>
        <DateInput
          name="form-field-name"
          data-id="export_print"
          object={(singleExport.value && singleExport.value.to) || null}
          onChange={(k, val) => {
            let exp = this.state.export;
            if (!exp.current.value) {
              exp.current.value = {};
            }
            exp.current.value.to = val;
            exp.disabled = !exp.current.value.courier || !exp.current.value.from;
            this.setState({export: exp});
          }}
        />
      </div>
    )
  }

  renderExport = () => {
    const singleExport = this.state.export.current;
    const form = !singleExport ? null :
      singleExport.type === "create" ? this.renderExportCreate() :
      singleExport.type === "upload" ? this.renderExportUpload() :
      singleExport.type === "choose" ? this.renderExportChoose() :
      singleExport.type === "print" ? this.renderExportPrint() :
      singleExport.type === "print_interval" ? this.renderExportPrintInterval() :
      singleExport.type === "scan" ? this.renderExportScan() :
      singleExport.type === "act" ? this.renderExportAct() :
      singleExport.type === "act_courier" ? this.renderCourierAct() :
      null;

    return (
      <Modal show={this.state.export.current !== null} onHide={this.onExportCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{singleExport ? singleExport.button : "..."}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {form}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onExportCancel}>{T("button_cancel")}</Button>
          <Button
            onClick={this.onExportConfirm} 
            bsStyle="primary"
            disabled={this.state.export.disabled}
          >{singleExport ? singleExport.confirm : "..."}</Button>
        </Modal.Footer>
      </Modal> 
    )
  }

  render = () => {

    // Selects and Export
    var selectColumn = null;
    var exports = null;
    var expConf = this.state.config.export;
    if (typeof expConf !== "undefined") {
      var needSelect = false;
      var disableExport = this.state.export.selected.length === 0;
      exports = Object.keys(expConf).map((key) => {
        const adminGroup = !!((this.props.user || {}).user_group || {}).admin;
        if (expConf[key].adminGroup && !adminGroup) {
          return null;
        }
        needSelect |= !expConf[key].noSelect;
        return (
          <a 
            key={key}
            data-key={key}
            className="btn button-export" 
            onClick={this.onExport}
            disabled={!expConf[key].noSelect && disableExport}
          >{expConf[key].button}</a>
        )
      });
      if (needSelect) {
        selectColumn = 
        <th width="40px">
          <input 
            type="checkbox"
            onChange={() => {}}
            onClick={this.onSelectAll}
            checked={this.state.objects.length === this.state.export.selected.length}
          />
        </th>;
      }
    }

    // Objects
    var columns = Object.keys(this.state.properties).map((key) => { // eslint-disable-line
      const adminGroup = !!((this.props.user || {}).user_group || {}).admin;
      if (this.state.properties[key].adminGroup && !adminGroup) {
        return null;
      }
      if (this.state.properties[key].width) {
        return (
          <th 
            key={key} 
            width={this.state.properties[key].width}
            >{this.state.properties[key].title}
          </th>
        )
      } else {
        return null;
      }
    });
    var objects = [];
    for (let i = 0; i < ITEMS_PER_PAGE; i++) {
      let index = this.state.page * ITEMS_PER_PAGE + i;
      if (index >= this.state.objects.length) {
        break;
      }
      let object = this.state.objects[index];
      objects.push(
        <ObjectListElem 
          key={index}
          user={this.props.user}
          method={this.state.config.method}
          configKey={this.props.configKey}
          onDelete={this.onObjectDelete}
          onView={this.onObjectView}
          onEdit={this.onObjectEdit}
          inSelection={$.inArray(object.id, this.state.export.selected) > -1}
          onSelect={this.onSelect}
          preset={this.state.config.preset}
          needSelect={selectColumn !== null}
          {...object}
        />
      );
    }

    // Search
    var searchView = null;
    if (typeof this.state.config.search !== "undefined") {
      searchView = 
      <SearchView
        config={this.state.config.search}
        onSearch={this.onSearch}
        user={this.props.user}
      />;
    }

    var editColumn = <th width="60px"></th>;
    var deleteColumn = <th width="75px"></th>;
    var addButton = <a className="btn button-add" onClick={this.onObjectCreate}>{T("button_add")}</a>
    if (this.state.config.preset) {
      addButton = null;
      editColumn = null;
      deleteColumn = null;
    }
    return (
      <div className="adminContent customScrollBar">
        <h1 className="page-header">
          {this.state.config.title}
        </h1>
        {searchView}
        <table className="table table-hover">
          <thead>
            <tr className="table-active">
              {selectColumn}
              {columns}
              {editColumn}
              {deleteColumn}
            </tr>
          </thead>
          <tbody>
            {objects}
          </tbody>
        </table>

        {this.renderPagination()}

        {addButton}
        <div className="exportBox">
          {exports}
        </div>

        <Modal show={this.state.showConfirm} onHide={this.onDeleteCancel}>
          <Modal.Header closeButton>
            <Modal.Title>{T("modal_delete_title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>
              {T("modal_delete_text")} {this.state.config.objectName} #{this.state.pendingDelete.id}?
            </h4>
            <p></p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onDeleteCancel}>{T("button_cancel")}</Button>
            <Button onClick={this.onDeleteConfirm} bsStyle="danger">{T("button_delete")}</Button>
          </Modal.Footer>
        </Modal> 

        {this.renderExport()}
        {this.renderResponse()}

      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/ObjectListView.js